<div class="flex items-center gap-4">
  <app-checkbox [formControl]="selected" />
  <div>
    <p class="text-base font-medium">{{ procedureName() }}</p>
    <span
      class="px-2 py-1 text-xs font-medium rounded text-text-50 bg-background-700 mt-2-"
      >Desconto de {{ discountInPercent() }}%</span
    >
  </div>
</div>
<div>
  <p class="text-lg font-bold">R$ {{ finalPrice() }}</p>
  <span class="text-sm font-medium line-through text-text-500">{{
    originalPrice()
  }}</span>
</div>
